import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

export const TableColumn = (t: TFunction<"translation", undefined>) => {
  return [
    {
      id: 1,
      key: "id",
      name: "ক্র: নং",
      render: (id: number) => (
        <Text color="subtitle1" className="text-nowrap">
          {id}
        </Text>
      ),
    },
    {
      id: 2,
      key: "nameBn",
      name: "কর্মরত কর্মকর্তা / কর্মচারীর নাম",
      render: (nameBn: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {nameBn}
        </Text>
      ),
    },
    {
      id: 3,
      key: "designation",
      name: "পদবি",
      render: (designation: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {designation}
        </Text>
      ),
    },
    {
      id: 4,
      key: "joiningDate",
      name: "চাকুরীতে যোগদানের তারিখ",
      render: (joiningDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {joiningDate}
        </Text>
      ),
    },
    {
      id: 5,
      key: "currentPositionJoiningDate",
      name: "বর্তমান পদে যোগদানের তারিখ",
      render: (currentPositionJoiningDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {currentPositionJoiningDate}
        </Text>
      ),
    },
    {
      id: 6,
      key: "currentPlaceJoiningDate",
      name: "বর্তমান কর্মস্থলে যোগদানের তারিখ",
      render: (currentPlaceJoiningDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {currentPlaceJoiningDate}
        </Text>
      ),
    },
    {
      id: 7,
      key: "previousOfficeNameBn",
      name: "পূর্ববর্তী কর্মস্থলের নাম",
      render: (previousOfficeNameBn: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {previousOfficeNameBn}
        </Text>
      ),
    },
    {
      id: 8,
      key: "birthDate",
      name: "জন্ম তারিখ",
      render: (birthDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {birthDate}
        </Text>
      ),
    },
    {
      id: 9,
      key: "prlDate",
      name: "পি আর এল -এ গমনের তারিখ",
      render: (prlDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {prlDate}
        </Text>
      ),
    },
    {
      id: 10,
      key: "districtNameBn",
      name: "নিজ জেলা ",
      render: (districtNameBn: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {districtNameBn}
        </Text>
      ),
    },
    {
      id: 11,
      key: "totalVacancy",
      name: "মন্তব্য",
    },
  ];
};
